import { LANGUAGES } from "constants/reactQueryKeys";
import { useQuery } from "react-query";
import { getLanguages } from "api/languages";

export const useGetLanguages = () => {
  return useQuery([LANGUAGES], () => getLanguages());
};
